import { Component, OnInit } from '@angular/core';
import { HighlightService } from 'src/app/@core/services/highligh.service';

@Component({
  selector: 'app-modal-doc',
  templateUrl: './modal-doc.component.html',
  styleUrls: ['./modal-doc.component.scss']
})
export class ModalDocComponent implements OnInit {
  highlighted: any;
  arrayComponent: any;
  componentRender: any;
  infoComponent: any;
  codeHtml: string;
  codeHtmlModalCorto : string;
  codeHtmlModalLargo : string;
  utils: any;

  constructor(private highlightService: HighlightService) { 
    this.utils = window.utils;

    this.arrayComponent = [
      {
        id: 'modalCorto',
        titulo: 'Modal Corto',
        subtitulo: '',
        claseContainer: 'col-10',
        componentRender:
        `<!-- Botón que activa el modal -->
        <button type="button" class="btn btn-round btn-high" data-toggle="modal" data-target="#modal-corto">Modal Corto</button>
        `,
      },
      {
        id: 'modalLargo',
        titulo: 'Modal Largo',
        subtitulo: '',
        claseContainer: 'col-10',
        componentRender:
        `<!-- Botón que activa el modal -->
        <button type="button" class="btn btn-round btn-high" data-toggle="modal" data-target="#modal-largo">Modal Largo</button>
        `,
      }
    ],
    this.infoComponent = {
      titulo: "Modales",
      subtitulo: ""
    },
    this.codeHtmlModalCorto = `
    <!-- Botón que activa el modal Corto-->
    <button type="button" class="btn btn-round btn-high" data-toggle="modal" data-target="#modal-corto">Modal Corto</button>

    <!-- Modal Corto-->
    <div class="modal fade show alert-modal" id="modal-corto" tabindex="-1" role="dialog" aria-labelledby="modal-title-govco" aria-hidden="true">
        <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Cerrar ventana" title="Cerrar ventana">x</button>
                </div>
                <div class="modal-body text-center modal-content-info">
                  <span class="govco-icon govco-icon-check-cn"></span>
                  <h2 class="headline-xl-govco">
                      Modal Corto
                  </h2>
                  <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Provident voluptate minima quae. Error, odio, dicta nam id aspernatur modi fugiat natus laboriosam placeat, voluptas a accusantium quos reprehenderit voluptates eos</p>
                </div>
            </div>
        </div>
    </div>
    `;
    this.codeHtmlModalLargo = `
    <!-- Botón que activa el modal Largo-->
    <button type="button" class="btn btn-round btn-high" data-toggle="modal" data-target="#modal-corto">Modal Corto</button>

    <!-- Modal Largo-->
    <div class="modal fade show alert-modal" id="modal-largo" tabindex="-1" role="dialog" aria-labelledby="modal-title-govco" aria-hidden="true">
        <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Cerrar ventana" title="Cerrar ventana">x</button>
                </div>
                <div class="modal-body text-center modal-content-info">
                  <span class="govco-icon govco-icon-check-cn"></span>
                  <h2 class="headline-xl-govco">
                      Modal Corto
                  </h2>
                  <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Provident voluptate minima quae. Error, odio, dicta nam id aspernatur modi fugiat natus laboriosam placeat, voluptas a accusantium quos reprehenderit voluptates eos</p>
                </div>
            </div>
        </div>
    </div>
    `;
  }

  ngAfterViewChecked() {
    if (!this.highlighted) {
      this.highlightService.highlightAll();
      this.highlighted = true;
    }
  }
  ngOnInit() {
    window.utils.init();
  }
  sharpenBackgroundModal(){
    this.utils.sharpenBackgroundModal()
  }

  blurredBackgroundModal(){
    this.utils.blurredBackgroundModal()
  }
}
